module.exports = __webpack_public_path__ + "static/media/teacher4.2c46fad3.svg";